import { useAuth } from "@/hooks/useAuth";
import type { HttpError } from "@/ts/api/comunicacion";
import styles from "./Loading.module.css";
import { useEffect, useState } from "react";

export function QueryError(props: { readonly error: unknown; readonly fallback: string; }) {
	const { setAuth } = useAuth();

	let message = props.fallback;
	if (props.error != null && typeof props.error === "object" && "status" in props.error) {
		const error = props.error as HttpError;
		if (error.status === 401) {
			setAuth(null);
			message = "Sesión expirada. Por favor, inicie sesión de nuevo.";
		} else if (error.status === 403) {
			message = "No tiene permiso para realizar esta acción.";
		}
	}


	return (
		<div style={{ padding: 20, color: "red", fontWeight: "bold" }}>
			{message}
		</div>
	);
}

interface LoadingProps {
	readonly style?: React.CSSProperties;
}
export function Loading(props: LoadingProps) {
	const [hasTimedOut, setHasTimedOut] = useState(false);

	useEffect(() => {
		const timeout = setTimeout(() => {
			setHasTimedOut(true);
		}, 10_000);

		return () => { clearTimeout(timeout); };
	}, []);

	return hasTimedOut ? (
		<div className={styles.timeout} role="alert" style={props.style}>
			<p>La carga está tardando más de lo esperado...</p>
		</div>
	) : (
		<div
			className={styles.loader}
			style={props.style}
			role="status"
			aria-label="Cargando"
		>
			<div />
			<div />
			<div />
		</div>
	);
}